const Abbreviation = [
  "ts",
  "te",
  "da",
  "lf",
  "vol",
  "apear",
  "color",
  "visc",
  "ph",
];

export default Abbreviation;
